// Los nombres se guardan en minúscula: "lucas euclides acevedo" ->
// "Lucas Euclides Acevedo".
export const capitalizeWords = (text) =>
  (text || "").toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

// Médico como se muestra en las tarjetas de indicaciones e informes:
// "Dr. Lucas Euclides Acevedo - M.N. 12345".
export const getDoctorLabel = (doctor) => {
  if (!doctor) return null;
  const name = capitalizeWords(
    [doctor.firstName, doctor.lastName].filter(Boolean).join(" ")
  );
  if (!name) return null;
  const license =
    doctor.doctor?.license?.number ||
    doctor.license?.number ||
    doctor.matricula ||
    null;
  const licenseType =
    doctor.doctor?.license?.type || doctor.license?.type || null;
  const licenseLabel = licenseType === "mp" ? "M.P." : "M.N.";
  return license ? `Dr. ${name} - ${licenseLabel} ${license}` : `Dr. ${name}`;
};
